import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteCadreRequest: ['response'],
    deleteCadreSuccess: ['response'],
    deleteCadreFailure: ['error'],
})

export const deleteCadreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteCadreRequest = state => state.merge({ success: null })

const deleteCadreSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteCadreFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_CADRE_REQUEST]: deleteCadreRequest,
    [Types.DELETE_CADRE_SUCCESS]: deleteCadreSuccess,
    [Types.DELETE_CADRE_FAILURE]: deleteCadreFailure,
})
